
import { OrdersReplacementApiRemoteService } from '../../Services/api/orders-replacement/orders-replacement-service'
import { IFormUsecase } from '../../Shared/Protocol/protocol-form-usecase'
import { Result } from '../../Shared/Protocol/protocol-result'


export class DestroyOrdersReplacementUseCase
implements IFormUsecase<string, void> {
  constructor (private readonly OrdersReplacementApi: OrdersReplacementApiRemoteService) {}
    
  public async handle (
    id: string
  ): Promise<Result<void>> {
    // eslint-disable-next-line no-useless-catch
    try {

      const response = await this.OrdersReplacementApi.destroy(id)

      if (response.isFailure) {
        return response
      }


      return Result.ok()
    } catch (error: any) {
      return Result.fail(error)
    }
  }

 
}
